import React from "react";
import "./ValentinesModal.scss";
import valenitines from "../../assets/images/valentinesMob.png"
import close from "../../assets/icons/close.svg"

const ValentinesModal = ({ onClose }) => {
    return (
        <div className="ValentinesModaloverlay-Dosa" onClick={onClose}>
            <div className="ValentinesModalbox-Dosa" onClick={(e) => e.stopPropagation()}
                style={{ backgroundImage: `url(${valenitines})` }}>
                <div className="ValentinesModalbox-Dosa-close" onClick={onClose}>
                    <img alt="" src={close} className="ValentinesModalbox-Dosa-close-ic" />
                </div>
            </div>
        </div>
    );
}
export default ValentinesModal
